/*
 * The potential energy savings card's period selector.
 */

export const ENERGY_PERIODS = ['3-months', '6-months', '12-months'] as const;

export type EnergyPeriod = typeof ENERGY_PERIODS[number];

export const DEFAULT_ENERGY_PERIOD: EnergyPeriod = '3-months';

/** i18n key for each period's label. */
export const PERIOD_LABEL_KEY: Record<EnergyPeriod, string> = {
  '3-months': 'dashboard.energyPeriod3Months',
  '6-months': 'dashboard.energyPeriod6Months',
  '12-months': 'dashboard.energyPeriod12Months',
};
